import { ContactListProps } from "./types"
import React from "react"
import { ContactListCore } from "./core"

const ContactList: React.FC<ContactListProps> = ({
  sections,
  swipeActionButtonConfigs,
  onItemClick,
  selecteds,
}) => {
  return (
    <ContactListCore
      sections={sections}
      swipeActionButtonConfigs={swipeActionButtonConfigs}
      onItemClick={onItemClick}
      selecteds={selecteds}
     />
  )
}

export default ContactList
